import { render, staticRenderFns } from "./MoviesHeader.vue?vue&type=template&id=4cf735c4&scoped=true"
import script from "./MoviesHeader.vue?vue&type=script&lang=js"
export * from "./MoviesHeader.vue?vue&type=script&lang=js"
import style0 from "./MoviesHeader.vue?vue&type=style&index=0&id=4cf735c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf735c4",
  null
  
)

export default component.exports